
import React from "react";
import './ContaFinanciara.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import contafinanciara from '../../imagesHome/contafinanciara.png'

const ContaFinanciara = () => {
  return (
    <div className="general-frame-bc-cf">
    <div className="general-frame-contafinanciara">
      <section className="bc-hero-shell">
        <div className="breadcrumb-bc">
          <span>Cursuri</span>
          <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
          <span className="current">Contabilitate Financiara</span>
        </div>
        <div className="bc-main-section">
          <div className="bc-main-left bc-main-left-contafinanciara">
            <img className="bc-main-img" src={contafinanciara} alt="contabilitate financiara" />
            <p className="bc-kicker">Curs avansat</p>
            <h1>Contabilitate Financiara</h1>
            <p>
              Treci la urmatorul nivel in contabilitate! Acest curs avansat te invata
              sa inregistrezi operatiuni complexe, sa intocmesti situatii financiare
              complete si sa interpretezi rezultatele unei companii.
            </p>
            <p>
              Vei aprofunda conceptele de recunoastere a veniturilor, evaluare a
              activelor, amortizare, provizioane si ajustari de bilant. Inveti cum
              sa aplici principiile contabile in practica.
            </p>
            <p>
              Este recomandat sa ai cunostinte de baza de contabilitate sau sa fi
              parcurs cursul "Bazele Contabilitatii".
            </p>

            <div className="bc-hero-actions">
              <Link to="/quiz-start" className="bc-primary-link">Incepe cursul</Link>
              <Link to="/cursuri-prezentare" className="bc-secondary-link">Vezi toate cursurile</Link>
            </div>
          </div>
          <div className="bc-main-right">
            <div className="bc-card">
              <div className="bc-card-badge">Avansat</div>
              <h2>Invata in ritmul tau</h2>
              <p>Acceseaza cursul "Contabilitate Financiara" si avanseaza in cariera cu exemple clare, aplicate.</p>

              <div className="bc-highlights">
                <div className="bc-highlight-item">
                  <span>01</span>
                  <span>Situatii financiare si raportare</span>
                </div>
                <div className="bc-highlight-item">
                  <span>02</span>
                  <span>Active, stocuri si evaluare</span>
                </div>
                <div className="bc-highlight-item">
                  <span>03</span>
                  <span>Analiza financiara si interpretare</span>
                </div>
              </div>

              <Link to="/quiz-start" className="bc-card-button">Creeaza cont gratuit</Link>
            </div>
          </div>
        </div>
      </section>

    </div>

      {/* 🔹 Secțiunea 2: Ce vei învăța */}
      <div className="cadru-bazeleconta-second">
        <div className="what-you-learn-section">
          <h2 className="section-title-bc">Ce vei invata in acest curs</h2>
          <p className="section-subtitle-bc">
            Aprofundeaza conceptele avansate de contabilitate financiara si invata sa intocmesti situatii financiare complete.
          </p>

          <div className="modules-grid-bc">
            {/* Modul 1 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 1</div>
              <h3 className="module-title-bc">Situatii financiare</h3>
              <p className="module-desc-bc">
                Invata sa intocmesti Bilantul, Contul de profit si pierdere, si Situatia fluxurilor de numerar conform standardelor.
              </p>
            </div>

            {/* Modul 2 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 2</div>
              <h3 className="module-title-bc">Active imobilizate</h3>
              <p className="module-desc-bc">
                Evaluare, inregistrare si amortizare a imobilizarilor corporale si necorporale. Reevaluari si deprecieri.
              </p>
            </div>

            {/* Modul 3 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 3</div>
              <h3 className="module-title-bc">Stocuri si cost de vanzare</h3>
              <p className="module-desc-bc">
                Metode de evaluare (FIFO, CMP), gestiunea stocurilor si calculul costului bunurilor vandute.
              </p>
            </div>

            {/* Modul 4 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 4</div>
              <h3 className="module-title-bc">Creante si datorii</h3>
              <p className="module-desc-bc">
                Recunoasterea si evaluarea creantelor, provizioane pentru depreciere, gestionarea datoriilor pe termen scurt si lung.
              </p>
            </div>

            {/* Modul 5 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 5</div>
              <h3 className="module-title-bc">Ajustari si regularizari</h3>
              <p className="module-desc-bc">
                Ajustari de finalizare, repartizarea cheltuielilor si veniturilor in avans, provizioane si regularizari.
              </p>
            </div>

            {/* Modul 6 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 6</div>
              <h3 className="module-title-bc">Analiza financiara</h3>
              <p className="module-desc-bc">
                Interpretarea indicatorilor financiari, ratele de rentabilitate, lichiditate si solvabilitate.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 3: Statistici curs */}
      <div className="stats-section-bc">
        <div className="stats-container-bc">
          <h2 className="section-title-bc">Ce include cursul</h2>
          
          <div className="stats-grid-bc">
            <div className="stat-item-bc">
              <div className="stat-number-bc">300+</div>
              <div className="stat-label-bc">Lectii avansate</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-number-bc">4000+</div>
              <div className="stat-label-bc">Quiz-uri si teste</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-number-bc">150+</div>
              <div className="stat-label-bc">Studii de caz</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-number-bc">40+</div>
              <div className="stat-label-bc">Certificari</div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 4: Beneficii */}
      <div className="benefits-section-bc">
        <div className="benefits-container-bc">
          <h2 className="section-title-bc">De ce sa alegi acest curs</h2>
          
          <div className="benefits-list-bc">
            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Conform cu standardele IAS/IFRS</h4>
                <p>Inveti principiile contabile internationale aplicabile in companii moderne</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Exemple din viata reala</h4>
                <p>Studii de caz si situatii concrete din practica contabila</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Aplicatii practice complexe</h4>
                <p>Intocmeste situatii financiare complete de la zero</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Pregatire pentru examene profesionale</h4>
                <p>Ideal pentru cei care pregatesc certificari CECCAR sau ACCA</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Actualizari permanente</h4>
                <p>Continutul se adapteaza la modificarile legislative si de reglementare</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Nivel avansat</h4>
                <p>Treci de la cunostinte de baza la competente profesionale solide</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 5: Final CTA */}
      <div className="final-cta-bc">
        <div className="cta-content-bc">
          <h2>Gata sa avansezi?</h2>
          <p>Inregistreaza-te gratuit si devino expert in contabilitate financiara!</p>
          <div className="cta-buttons-bc">
            <Link to="/quiz-start" className="bc-primary-link bc-cta-link">Creeaza cont gratuit</Link>
            <div className="sau-cta-bc">sau</div>
            <Link to="/cursuri-prezentare" className="bc-secondary-link bc-cta-link">Vezi toate cursurile</Link>
          </div>
        </div>
      </div>

    </div>

  );
};

export default ContaFinanciara;



